import { DETECTOR_RESULTS } from '@/constants/requirementVariables';

export default class RuleEngine {
  constructor(schema) {
    this.schema = schema;
  }

  isValidCondition(condition) {
    const { variables, variable_type_operators: typeOperators } = this.schema;
    const matchingVariable = variables.find(
      (variable) => variable.name === condition.name,
    );
    if (!matchingVariable) {
      return false;
    }

    const allowedOperators = typeOperators[matchingVariable.field_type];
    const operator =
      allowedOperators &&
      allowedOperators.find((operator) => operator.name === condition.operator);
    if (!operator) {
      return false;
    }

    if (condition.function_value && !condition.value) {
      return matchingVariable.function_options.find(
        (value) => value === condition.function_value,
      );
    }

    if (Array.isArray(condition.value)) {
      const isNotEmpty = condition.value.length > 0;

      if (operator.input_type === 'create_multiple') {
        return (
          isNotEmpty &&
          condition.value.every(
            (conditionValue) => conditionValue && conditionValue.length > 0,
          )
        );
      }
      return (
        isNotEmpty &&
        condition.value.every((conditionValue) =>
          matchingVariable.options.find((value) => value === conditionValue),
        )
      );
    }

    if (this.isNumeric(matchingVariable) || this.isBoolean(matchingVariable)) {
      return condition.value && !isNaN(condition.value);
    }

    return matchingVariable.options.find((value) => value === condition.value);
  }

  isValidConditionSet(conditions) {
    return conditions.every((condition) => this.isValidCondition(condition));
  }

  isValidRule(rule) {
    return (
      rule.conditions.all.length > 0 &&
      this.isValidConditionSet(rule.conditions.all)
    );
  }

  isValidRuleSet(rules, customValidator = () => true) {
    return rules.every(
      (rule) => this.isValidRule(rule) && customValidator(rule),
    );
  }

  isNumeric(variable) {
    return (
      variable &&
      (variable.field_type === 'numeric' ||
        variable.field_type === 'trust_score' ||
        variable.field_type === 'quality_score')
    );
  }

  isNumericWithMax(variable) {
    return (
      variable &&
      (variable.field_type === 'trust_score' ||
        variable.field_type === 'quality_score')
    );
  }

  isBoolean(variable) {
    return variable && variable.field_type === 'boolean';
  }

  isText(variable) {
    return variable && variable.field_type === 'document_text';
  }

  static isSimpleDetectorRule(rule) {
    return (
      rule.default &&
      rule.conditions.all.length === 1 &&
      rule.conditions.all[0].name === DETECTOR_RESULTS &&
      rule.conditions.all[0].value.length === 1
    );
  }

  static getRuleTitle(rule) {
    const title = rule.display_name || rule.name;
    return title.replace('_BLACKLIST', '');
  }
}
